// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__aYCho","colMin":"styles_colMin__2C8vj","colCheckbox":"styles_colCheckbox__2zyJY"};